import { useEffect, useState } from "react";
import { X, MessageCircle, Star } from "lucide-react";
import { buildWhatsAppOrderUrl } from "@/lib/contact";

const POPUP_IMG = "https://customer-assets-agu9un31.emergentagent.net/job_cat-cage-shop/artifacts/aamtpp3b_IMG_1930.jpeg";
const STORAGE_KEY = "sme_popup_seen_v1";

export const WelcomePopup = () => {
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const seen = localStorage.getItem(STORAGE_KEY);
    if (!seen) {
      const t = setTimeout(() => setOpen(true), 1500);
      return () => clearTimeout(t);
    }
  }, []);

  const handleClose = () => {
    localStorage.setItem(STORAGE_KEY, "1");
    setOpen(false);
  };

  if (!open) return null;

  return (
    <div
      className="fixed inset-0 z-[9998] flex items-center justify-center p-4 animate-fade-up"
      data-testid="welcome-popup"
      role="dialog"
      aria-modal="true"
    >
      {/* Backdrop */}
      <div
        onClick={handleClose}
        className="absolute inset-0 bg-[#1C1C1C]/70 backdrop-blur-sm"
      />

      {/* Card */}
      <div className="relative w-full max-w-[880px] bg-[#FAF9F6] rounded-[2rem] overflow-hidden shadow-[0_40px_90px_rgba(0,0,0,0.35)] grid grid-cols-1 md:grid-cols-2">
        <button
          onClick={handleClose}
          data-testid="popup-close-btn"
          aria-label="Tutup"
          className="absolute top-4 right-4 z-10 w-10 h-10 rounded-full bg-white/95 hover:bg-white text-[#1C1C1C] flex items-center justify-center shadow-[0_6px_20px_rgba(0,0,0,0.15)] transition"
        >
          <X className="w-5 h-5" />
        </button>

        {/* Image */}
        <div className="relative aspect-square md:aspect-auto md:min-h-[440px] bg-[#F4F1EA]">
          <img
            src={POPUP_IMG}
            alt="Pelanggan Sangkar Murah Enterprise"
            className="w-full h-full object-cover"
          />
          <div className="absolute bottom-4 left-4 inline-flex items-center gap-2 px-3 py-1.5 rounded-full bg-white/90 backdrop-blur">
            <div className="flex items-center gap-0.5">
              {[...Array(5)].map((_, i) => (
                <Star key={i} className="w-3 h-3 fill-[#E07A5F] text-[#E07A5F]" />
              ))}
            </div>
            <span className="text-[10px] font-bold tracking-wider uppercase text-[#1C1C1C]">
              Pelanggan Puas Hati
            </span>
          </div>
        </div>

        {/* Content */}
        <div className="p-8 sm:p-10 lg:p-12 flex flex-col justify-center">
          <div className="label-eyebrow text-[#E07A5F]">Selamat Datang</div>
          <h2 className="font-heading font-bold text-3xl sm:text-4xl tracking-tight text-[#1C1C1C] mt-3 leading-[1.1] text-balance">
            Sangkar kucing custom-made siap dalam <span className="text-[#E07A5F]">4–5 hari</span>.
          </h2>
          <p className="text-sm text-[#4A4A4A] mt-4 leading-relaxed">
            Terima kasih kepada pelanggan setia kami! Setiap sangkar dibuat khas
            mengikut saiz dan warna pilihan anda. WhatsApp kami sekarang untuk
            sebut harga percuma.
          </p>

          <a
            href={buildWhatsAppOrderUrl()}
            target="_blank"
            rel="noreferrer"
            onClick={handleClose}
            data-testid="popup-whatsapp-btn"
            className="mt-7 inline-flex items-center justify-center gap-2 px-6 py-4 rounded-xl bg-[#25D366] text-white hover:bg-[#1EBE57] transition-all duration-300 font-semibold text-sm shadow-[0_10px_30px_rgba(37,211,102,0.28)]"
          >
            <MessageCircle className="w-4 h-4" />
            Tempah via WhatsApp Sekarang
          </a>
          <button
            onClick={handleClose}
            data-testid="popup-later-btn"
            className="mt-3 text-xs text-[#4A4A4A] hover:text-[#1C1C1C] font-medium"
          >
            Lihat katalog dahulu
          </button>
        </div>
      </div>
    </div>
  );
};
